"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // @ts-check

/**
 * @param  {...Function[]} fns
 * @returns {object}
 */

var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return fns.reduce(function (v, f) {
      return f(v);
    }, props);
  };
};

var _default = pipe;
exports.default = _default;